import { Button, Col, Form, message, Row, Typography } from "antd";
import { useForm } from "../../utils/hooks/useForm";
import FloatInput from "../../components/FloatInput/floatInput";
import { useAuth } from "../../utils/hooks/useAuth";
import "./verifyOTP.modules.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ChevronLeft } from "../../assets/chevron-left.svg";
import { useCountDown } from "../../utils/hooks/useCountDown";
import { useState } from "react";
import { allowNumOnly } from "../../utils/methods/form-validations";
import WPLayout from "../../components/WPLayout/WPLayout";

const VerifyOTPNetwork = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { form } = useForm();
  const {
    handleVerifyNetworkOTP,
    handleResendNetworkOtp,
    isLoading,
    isApiLoading,
  } = useAuth(form);
  const { count, resetCount } = useCountDown(60);
  const [isResetCode, setIsResetCode] = useState(false);

  const handleResetCode = () => {
    resetCount();
    setIsResetCode(true);
    form?.submit();
  };

  const onFinish = async (values: { otp: string }) => {
    try {
      if (isResetCode) {
        await handleResendNetworkOtp(
          location.state.phoneNumber || "",
          location.state.npiNumber || "",
          resetCount,
        );
        return;
      }
      await handleVerifyNetworkOTP({
        npi_number: location.state.npiNumber,
        phoneNumber: location.state.phoneNumber,
        otp: values.otp.toString(),
      });
    } catch (error) {
      message.error(`${error}`);
    } finally {
      setIsResetCode(false);
    }
  };

  return (
    <WPLayout>
      <div className="flex flex-col justify-center items-center w-full max-w-[1440px] overflow-y-hidden mobile-lg:h-full mx-auto">
        <div className="my-2 flex flex-col justify-center items-center w-full px-6 py-4 max-w-[1440px] mx-auto h-full">
          <Form
            form={form}
            name="signup"
            onFinish={onFinish}
            className="my-6 pt-2 flex flex-col bg-[white] w-full max-w-[470px] justify-center items-center rounded-xl mobile-m:rounded-3xl px-2 mobile-m:px-4"
          >
            <div className="flex flex-col justify-center items-center max-w-[380px] w-full">
              <div className="w-full flex justify-between items-center mt-4 lg:mt-8">
                <Button
                  className="bg-transparent border-solid border-[#d5d7da] text-[#A8BDC1] rounded-[8px] p-4 hover:bg-[#e8f3ff] hover:text-[#7e5aeb]"
                  icon={<ChevronLeft />}
                  onClick={() => navigate("/signup-new")}
                />
                <Typography.Text className="w-full mr-8 font-playfair text-center text-3xl text-[#0F0F1C] font-semibold">
                  {"Verify OTP"}
                </Typography.Text>
              </div>
              <Typography.Text className="m-4 mb-2 font-inter text-center leading-4 text-[12px] text-normal text-[#5d6769] mobile-m:text-sm mobile-m:mb-4">
                Please verify your phone number with OTP below.
              </Typography.Text>

              <Row
                gutter={[12, 12]}
                className={`w-full justify-center items-center`}
              >
                <Col span={24}>
                  <Form.Item
                    name="otp"
                    rules={[
                      {
                        ...(!isResetCode && {
                          required: true,
                          message: "Please enter the OTP.",
                        }),
                      },
                      {
                        pattern: /^\d{6}$/,
                        message: "OTP must be a 6-digit number.",
                      },
                    ]}
                  >
                    <FloatInput
                      type="text"
                      placeholder="XXXXXX"
                      maxLength={6}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        allowNumOnly(e, form, "otp")
                      }
                      controls={false}
                      onPressEnter={() => form.submit()}
                      label="OTP Number"
                      required={true}
                    />
                  </Form.Item>
                </Col>
                <div className="flex flex-col justify-center items-center mb-8 gap-y-4 w-full">
                  {!!count ? (
                    <Typography.Text className="font-urbanist text-[#7e5ae2] font-semibold text-lg w-full text-center leading-[28px] tracking-[0px]">
                      Resend OTP in {count}
                    </Typography.Text>
                  ) : (
                    <Button
                      className="font-urbanist text-[#7e5ae2] font-semibold text-lg text-center"
                      type="link"
                      block
                      onClick={handleResetCode}
                    >
                      Resend OTP
                    </Button>
                  )}
                  <Button
                    type="primary"
                    htmlType={"submit"}
                    loading={isLoading || isApiLoading}
                    className={`font-urbanist font-semibold bg-[#7e5ae2] w-[96%] mobile-m:w-full mobile-m:max-w-[370px] rounded-full py-[30px] mobile-m:px-[0px] border-none text-base`}
                  >
                    Verify Phone Number
                  </Button>
                </div>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    </WPLayout>
  );
};

export default VerifyOTPNetwork;
